import { render, staticRenderFns } from "./Woyaopeixun.vue?vue&type=template&id=3a30929a&scoped=true"
import script from "./Woyaopeixun.vue?vue&type=script&lang=js"
export * from "./Woyaopeixun.vue?vue&type=script&lang=js"
import style0 from "./Woyaopeixun.vue?vue&type=style&index=0&id=3a30929a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30929a",
  null
  
)

export default component.exports